<template>
  <section id="thank-you">
    <div class="container">
      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-10">
          <div align="center">
            <div class="succesful-circle">
              <i class="far fa-check-circle icon-succesful"></i>
            </div>
            <h2 class="page-title">
              {{$t("thankYou.title")}}
            </h2>
            <p class="page-text">
              {{$t("thankYou.message")}}
            </p>
            <div class="mt-40" align="center">
              <router-link to="/events">
                <button class="button-blue-success">
                  {{$t("thankYou.events")}}
                </button>
              </router-link>
            </div>
          </div>
        </div>
        <div class="col-md-1"></div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Checkout.ThankYou"
}
</script>

<style lang="scss">
  @import '../../scss/variables.scss';

  #thank-you {
    margin: 100px 0;
  }

  .succesful-circle {
    width: 104px;
    height: 104px;
    border-radius: 50px;
    text-align: center;
    background: rgba(172, 232, 148, 0.2);

    .icon-succesful {
      text-align: center;
      font-size: 55px;
      margin-top: 24px;
      color: rgba(172, 232, 148, 1);
    }
  }
</style>
